import React from "react";
import { useTranslation } from "react-i18next";

import {
  Comment,
  Identifiable,
  event,
  milestone,
  project,
  task,
} from "@planzone/dto";
import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { MemberAvatar } from "@common/memberAvatar";
import { Props } from "./types";
import styles from "./styles.scss";

function Log({ log }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();
  const submissionDate = new Date(log.createdDate);

  const showEntity = (log: Identifiable<Comment>) => {
    if (!log.attributes?.elementUuid) return;
    log.content.includes("Task") &&
      pushView({
        key: UseCases.retrieveTask,
        data: {
          task: {
            ...task,
            uuid: log.attributes?.elementUuid,
          },
        },
      });
    log.content.includes("Event") &&
      pushView({
        key: UseCases.retrieveEvent,
        data: {
          event: {
            ...event,
            uuid: log.attributes?.elementUuid,
          },
        },
      });
    log.content.includes("Activity") &&
      pushView({
        key: UseCases.retrieveList,
        data: {
          listId: log.attributes?.elementUuid,
        },
      });
    log.content.includes("Milestone") &&
      pushView({
        key: UseCases.retrieveMilestone,
        data: {
          milestone: { ...milestone, uuid: log.attributes?.elementUuid },
        },
      });
    log.content.includes("Project") &&
      pushView({
        key: UseCases.retrieveProject,
        data: {
          project: {
            ...project,
            uuid: log.attributes.elementUuid,
          },
        },
      });
  };

  return (
    <div className={styles.log}>
      <div className={styles.content}>
        <div className={styles.avatar}>
          <MemberAvatar
            avatarUrl={log.author.avatarUrl}
            name={log.author.name}
          />
        </div>
        <p className={styles.title}>
          {t(`projectLogs.log.${log.content}`, { author: log.author.name })}
        </p>
        {!log.content.includes("Project") &&
        !log.content.includes("Activity") ? (
          <p
            className={styles.redirection}
            onClick={() => showEntity(log)}
          >{`${log.attributes?.path}${log.attributes?.name}`}</p>
        ) : (
          <p className={styles.redirection} onClick={() => showEntity(log)}>
            {`${log.attributes?.path}`.slice(0, -2)}
          </p>
        )}
      </div>
      <p className={styles.submissionDate}>
        {submissionDate.toLocaleDateString()} {submissionDate.getHours()}h
        {submissionDate.getMinutes().toString().padStart(2, "0")}
      </p>
    </div>
  );
}

export { Log };
